import { Component, Input, ViewEncapsulation } from "@angular/core";

import { DragStylingService } from "../drag-styling.service";
import { FieldType } from "../vforms-model";

@Component({
    selector: "toolbar",
    templateUrl: "toolbar.component.html",
    styleUrls: ["toolbar.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class ToolbarComponent {
    @Input()
    fieldTypes: FieldType[];

    constructor(private _dragStylingService: DragStylingService) {}

    onDragStarted() {
        this._dragStylingService.isDragging$.next(true);
    }

    onDragEnded() {
        this._dragStylingService.isDragging$.next(false);
    }
}
